/* FRED'S 1928 — product hero behaviour.
 *
 * Two jobs, both small:
 *   1. Gallery thumbnails swap the main image.
 *   2. Variant pills update the price and tell fg-fastbuy which variant is
 *      selected.
 *
 * On (2): fg-fastbuy owns the cart request, quantity, store selection and
 * fulfilment rules. This file never touches the cart; it only tells fastbuy
 * which variant is selected.
 *
 * Careful with the contract — there are two and only one is live:
 *
 *   assets/fg-fastbuy.js  listens for `variant-change` (hyphen) but resolves
 *                         its input with `[data-fg-variant]`, an attribute
 *                         the markup never emits (it is `data-fg-variant-id`).
 *                         That listener is dead code.
 *
 *   snippets/fg-fastbuy   inline script listens for `variant:change` (colon)
 *                         and expects `detail.variant` to be the *whole*
 *                         variant object, not just an id — it reads quantity
 *                         rules and availability off it.
 *
 * So we dispatch `variant:change` and hand it a full variant object, taken
 * from fastbuy's own `[data-fg-variants]` JSON so the shape is guaranteed to
 * be the one it expects.
 */
(function () {
  'use strict';

  function initGallery(root) {
    var stage = root.querySelector('[data-freds-stage]');
    var thumbs = root.querySelectorAll('[data-freds-thumb]');
    if (!stage || !thumbs.length) return;

    thumbs.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var src = btn.getAttribute('data-freds-thumb');
        if (!src) return;
        stage.src = src;
        // srcset would otherwise keep winning over the new src.
        stage.removeAttribute('srcset');
        thumbs.forEach(function (t) { t.classList.remove('is-active'); });
        btn.classList.add('is-active');
      });
    });
  }

  function readVariants(root) {
    var el = root.querySelector('[data-fg-variants]');
    if (!el) return [];
    try { return JSON.parse(el.textContent) || []; } catch (e) { return []; }
  }

  function initVariants(root) {
    var wrap = root.querySelector('[data-freds-pills]');
    if (!wrap) return;

    var pills = wrap.querySelectorAll('[data-freds-variant]');
    var priceEl = root.querySelector('[data-freds-price]');
    var variants = readVariants(root);

    pills.forEach(function (pill) {
      pill.addEventListener('click', function () {
        if (pill.hasAttribute('disabled')) return;

        pills.forEach(function (p) { p.classList.remove('is-active'); });
        pill.classList.add('is-active');

        var id = pill.getAttribute('data-freds-variant');
        var price = pill.getAttribute('data-freds-price');

        if (priceEl && price) {
          // Keep any compare-at strike-through that follows the price node.
          var was = priceEl.querySelector('.freds-php__price-was');
          priceEl.textContent = price;
          if (was) priceEl.appendChild(was);
        }

        // Reflect the choice in the URL so a refresh or a share keeps it.
        try {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', id);
          window.history.replaceState({}, '', url);
        } catch (e) { /* older browsers: not important enough to fail on */ }

        // Hand fastbuy the whole variant object it expects.
        var variant = null;
        for (var i = 0; i < variants.length; i++) {
          if (String(variants[i].id) === String(id)) { variant = variants[i]; break; }
        }
        if (!variant) variant = { id: Number(id) || id };

        document.dispatchEvent(new CustomEvent('variant:change', {
          detail: { variant: variant }
        }));

        // Belt and braces: if no listener updated the hidden input, set it
        // directly so the cart request still carries the right variant.
        var hidden = root.querySelector('[data-fg-variant-id]');
        if (hidden && String(hidden.value) !== String(id)) {
          hidden.value = String(id);
        }
      });
    });
  }

  function boot() {
    var root = document.querySelector('.freds-php');
    if (!root) return;
    initGallery(root);
    initVariants(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
